const {
  CREATURE_TINY_SERVANT,
} = require('./../../creatureIdList')

const Tiny_servant_img_XGTE = require('./../../../images/creatures/xgte/tiny_servant.jpg')

module.exports = {
  [CREATURE_TINY_SERVANT]: Tiny_servant_img_XGTE,
}
